import { FuseAnimate, FuseSplashScreen } from "@fuse";
import _ from "@lodash";
import { Card, CardContent, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as userActions from "app/Core/Funcionalidade/Auth/store/actions";
import { setPreloadAuth } from "app/Core/Funcionalidade/Auth/store/actions";
import * as Helpers from "app/Core/Helpers";
import PWAApp from "app/Core/PWA/PWAApp";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import Constante from "Constante.json";
import history from "history.js";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import LoginFirebase from "./LoginFirebase";

const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText
    },
    paper: {
        width: "70%",
    },
    card: {
        background: theme.palette.type === "dark" ? "#494949" : "#FFFFFF",
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#494949",
    },
    version: {
        position: "absolute",
        right: 12,
        bottom: 12,
        cursor: "pointer"
    },
    content: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 10,
    },
    bgTheme: {
        backgroundColor: theme.palette.primary.main
    }
});

class Login extends XAPPComponent {

    state = {
        tabValue: 0
    };

    componentDidMount() {
        this.sessionClear();
        Helpers.checkRedirectAuth();
    }

    handleTabChange = (event, value) => {
        this.setState({ tabValue: value });
    };

    sessionClear = () => {
        if (!_.isUndefined(navigator.serviceWorker)) {
            navigator.serviceWorker.register("/service-worker.js").then(reg => {
                reg.update();
            });
        }
        window.sessionStorage.clear();

    };

    Logar = () => {
        const { search } = document.location;
        let APath = "/pub-login";
        let AGoogleToken = sessionStorage.getItem("google_access_token");
        let ARecaptcha = sessionStorage.getItem("recaptcha");
        this.props.setPreloadAuth(1);
        FirebaseAuthService.signInWithFirebase()
            .then(resp => {
                if (!_.isNull(resp)) {
                    if (!_.isUndefined(resp.organizacoes) && !_.isNull(resp.organizacoes) && resp.organizacoes.length === 1 && resp.organizacoes[0].url_ui !== document.location.origin) {
                        APath = resp.organizacoes[0].url_ui + "&tk=" + AGoogleToken + "&cap=" + ARecaptcha + "&usr=" + resp.user.data.username + "&login=" + resp.user.data.login;
                        if (!_.isUndefined(search)) {
                            APath = APath + "&" + search.substring(1);
                        }
                        document.location.href = APath;
                    }
                    else if (!_.isUndefined(resp.organizacoes) && !_.isNull(resp.organizacoes) && resp.organizacoes.length > 1) {
                        APath = "/pub-organizacao?c=" + new Date().getTime() + "&tk=" + AGoogleToken + "&cap=" + ARecaptcha + "&usr=" + resp.user.data.username + "&login=" + resp.user.data.login;
                        this.props.setOrganizacoes(resp.organizacoes);
                        if (!_.isUndefined(search)) {
                            APath = APath + "&" + search.substring(1);
                        }
                        history.push(APath);
                    }
                    else if (document.location.pathname === "/pub-login") {
                        APath = "/token?tk=" + AGoogleToken + "&cap=" + ARecaptcha + "&usr=" + resp.user.data.username + "&login=" + resp.user.data.login;
                        if (!_.isUndefined(search)) {
                            APath = APath + "&" + search.substring(1);
                        }
                        //history.push(APath);
                        document.location.href = document.location.origin + APath;
                    }
                    else {
                        this.sessionClear();
                        //history.push(APath);
                        document.location.href = document.location.origin + APath;
                    }
                }
            })
            .catch(error => {
                if (error) {
                    history.push("/pub-login");
                    this.showMessageAutenticacao(error);
                    this.props.setPreloadAuth(0);
                }
            })
            .finally(() => {
                this.props.setPreloadAuth(0);
            });
    };

    showMessageAutenticacao = (message) => {
        var AMensagem = message;
        if (message === "Network Error") {
            AMensagem = "Servidor indisponível!";
        }
        else if (message.toString().includes("code 500")) {
            AMensagem = "Servidor indisponível!";
        }
        else if (message.toString().includes("Sessão expirada")) {
            AMensagem = null;
        }

        if (AMensagem !== null) {
            this.props.showMessage({
                message: AMensagem,
                variant: "error"
            });
        }
    };

    render() {
        const { classes, theme } = this.props;

        return (
            <React.Fragment>
                {_.isNull(Helpers.checkRouteAuth()) ?
                    <div className={clsx(classes.root, "flex flex-col flex-1 flex-no-shrink p-0 md:flex-row")}>
                        <div className={clsx("flex-col flex-no-grow items-center text-white p-16 text-center md:p-128 md:flex-no-shrink md:flex-1 md:text-left justify-center md:flex sm:hidden xs:hidden")}>
                            <div className={clsx(classes.paper, "flex justify-center")}>
                                <img
                                    className={clsx(classes.bgTheme, "justify-center")}
                                    src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                                    alt="Logo principal"
                                />
                            </div>
                        </div>
                        <FuseAnimate animation={{ translateX: [0, "100%"] }}>
                            <Card className={clsx(classes.card, "w-full max-w-400 mx-auto m-16 md:m-0")} square>
                                <PWAApp />
                                <CardContent className={clsx(classes.content, "flex flex-col items-center justify-center py-32 mx-28 my-36 md:m-36")}>
                                    <img
                                        id="logoPrincipal"
                                        className={clsx(classes.bgTheme, "md:hidden sm:flex mb-12 h-52")}
                                        src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                                        alt="Logo principal"
                                    />
                                    <LoginFirebase
                                        callback={this.Logar}
                                    />
                                    <div className="flex flex-col items-center justify-center pt-16">
                                        <span className="font-medium">Não possui uma conta?</span>
                                        <Link className="font-medium cursor-pointer" to={"/pub-register"}>Criar conta</Link>
                                    </div>
                                </CardContent>
                                <div className={classes.version} onClick={() => { document.location.reload(true); }}>
                                    <span className="font-medium">{"v. " + Constante.versao}</span>
                                </div>
                            </Card>
                        </FuseAnimate>
                    </div>
                    :
                    <FuseSplashScreen />
                }
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setUserData: userActions.setUserData,
        showMessage: AppActions.showMessage,
        setNavigation: AppActions.setNavigation,
        setOrganizacoes: userActions.setOrganizacoes,
        setPreloadAuth: setPreloadAuth,
    }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
    return {
        theme: fuse.settings.mainTheme,
        user: auth.user.data,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Login)));
